import { render } from "./DuihuanSmsCheck.vue?vue&type=template&id=3980f99e&scoped=true"
import script from "./DuihuanSmsCheck.vue?vue&type=script&lang=js"
export * from "./DuihuanSmsCheck.vue?vue&type=script&lang=js"

import "./DuihuanSmsCheck.vue?vue&type=style&index=0&id=3980f99e&scoped=true&lang=stylus"

import exportComponent from "/Users/test/Desktop/source/work/H5-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3980f99e"]])

export default __exports__